import apiClient from '../api/api';
import { API_ENDPOINTS } from '../api/api.config';

export interface GoogleDriveFile {
  id: string;
  name: string;
  mimeType: string;
  size?: string;
  createdTime: string;
  path: string;
  children?: GoogleDriveFile[];
}

export interface GoogleDriveListResponse {
  success: boolean;
  code: number;
  data: GoogleDriveFile;
}

export interface GoogleDriveUploadFolderRequest {
  access_token: string;
  folder_id: string;
  folder_name: string;
  upload_type: string;
}

export interface GoogleDriveUploadFolderResponse {
  success: boolean;
  code: number;
  message?: string;
}

class GoogleDriveService {
  // GET: Initiate Google Drive authorization
  async authorize() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.GOOGLE_DRIVE.AUTH);
      return response;
    } catch (error) {
      console.error('Error authorizing Google Drive:', error);
      throw error;
    }
  }

  // GET: List files from Google Drive
  async listFiles(accessToken: string): Promise<GoogleDriveListResponse> {
    try {
      const response = await apiClient.get(
        `${API_ENDPOINTS.GOOGLE_DRIVE.LIST_FILES}?access_token=${accessToken}`
      );
      return response.data;
    } catch (error) {
      console.error('Error listing Google Drive files:', error);
      throw error;
    }
  }

  // PUT: Upload folder from Google Drive with processing
  async uploadFolder(data: GoogleDriveUploadFolderRequest): Promise<GoogleDriveUploadFolderResponse> {
    try {
      const response = await apiClient.put(
        API_ENDPOINTS.GOOGLE_DRIVE.UPLOAD_FOLDER,
        data
      );
      return response.data;
    } catch (error) {
      console.error('Error uploading Google Drive folder:', error);
      throw error;
    }
  }

  // LocalStorage helpers
  static saveToken(token: string) {
    localStorage.setItem('google_drive_token', token);
  }

  static getToken(): string | null {
    return localStorage.getItem('google_drive_token');
  }

  static removeToken() {
    localStorage.removeItem('google_drive_token');
  }
}

export const googleDriveService = new GoogleDriveService();
export default googleDriveService;
